module.exports = __webpack_public_path__ + "static/img/051_TO8_1585.9a09667.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/051_TO8_1585.jpg
// module id = UDS6
// module chunks = 0